<template>
  <div class="key-info" v-if="hotel.key_collection_info">
    <div class="key-info__wrap">
      <p class="key-info__title">Recupero della chiavi</p>
      <span v-if="hotel.key_collection_info.how_to_collect" class="key-info__item">
        Come raccogliere le chiavi: {{ get_key_collection(hotel.key_collection_info.how_to_collect) }}
      </span>
      <span v-if="hotel.key_collection_info.key_location" class="key-info__item">
        Posizione delle chiavi: {{ get_key_collection(hotel.key_collection_info.key_location) }}
      </span>
      <p
        v-if="hotel.key_collection_info.alternative_key_location && Object.keys(hotel.key_collection_info.alternative_key_location).length"
        class="key-info__item"
      >
        Chiave alternativa situata in:
        <template v-for="(location, location_index) in hotel.key_collection_info.alternative_key_location">
          <span :key="_uid+'location'+location_index">
            {{ location }}
          </span>
        </template>
      </p>
      <span class="key-info__item" v-if="hotel.key_collection_info.other_text">
        {{ hotel.key_collection_info.other_text }}
      </span>
    </div>
  </div>
</template>

<script>
import {get_key_collection} from "@bookingv3/resources"

export default {
  name: 'key-info',

  components: {
  },

  props: {
    hotel: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
    this.get_key_collection = get_key_collection
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .key-info {

    &__title {
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 10px;
    }

    &__item {
      display: block;
      margin-top: 5px;

      &:first-child {
        margin-top: 0;
      }
    }
  }

</style>